import React,{useState, useEffect}  from 'react';
import Sides from '../Bars/Csidebar';
import { Helmet } from "react-helmet";
import Button from 'react-bootstrap/Button'
function Ccontrolstat(){

    const [padding, setWindowpadding] = useState(0);
    const [width, setWindowWidth] = useState(0);
    useEffect(() => {
      updateDimensions()
  
      window.addEventListener('resize', updateDimensions)
      return () => window.removeEventListener('resize', updateDimensions)
    }, [])
  
    const updateDimensions = () => {
      const width = window.innerWidth
      setWindowWidth(width)
      if (width < 998) {
        setWindowpadding(2.5)
      } else {
        setWindowpadding(14)
      }
    }
  
    
    const right = {
      padding: '0 0 0 '+padding+'rem',
    };
return(
    <div>
        <Sides/>
         <Helmet>
 
 <title>C Control structure statement tutorial For Beginners</title>
 <meta name="description" content="C Control structure statement tutorial for beginners.program is executed as per requirement according to requirement the sequence can be changed by using the control structure statement, CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,learn code in free,c programming tutorial for beginners,learn code in free online,continue statement in c programming,control structure statement in c,control structure in c" />
 <link rel="canonical" href="https://www.codeexampler.com/c-control-structure" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">C Control structure statement</h1>
    <div className="first">
        <a href="/c-operator"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-if"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
   
   
    <p className="mt-4 para">The program is executing according to requirement, and the sequence can be changed using the control structure statement. The categories and keywords show Below:
</p>
    
<h2 className="mt-4 mh2">Conditional statement:<br/></h2>
<h3 className="mt-4 mh3">The conditional statement is many types in C:<br/>
</h3>
<h4 className="mt-4">If-condition <br/>
If-else<br/>
If-else-if<br/>
Nested if<br/>
Switch-case
</h4>
<h2 className="mt-4 mh2">C looping (iteration)<br/></h2>
<h3 className="mt-4 mh3"> There are Three types of looping in C:<br/>
</h3>
<h4 className="mt-4">While loop<br/>
Do-while loop<br/>
For loop<br/>
</h4>
<h2 className="mt-4 mh2">Jumping statements in C:<br/></h2>
<h3 className="mt-4 mh3">C supports only three types of jumping statements in C: 
<br/></h3>
<h4 className="mt-4">Break<br/>
Continue<br/>
Goto<br/>
return<br/>
</h4>
<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/c-operator">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Ccontrolstat;